export const getExceptionFilters = state => state.exception.exceptionFilters;

export const getExceptionGridSortCriteria = state => state.exception.exceptionGridSortCriteria;
